import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, EMPTY, Observable, throwError, from } from 'rxjs';
import { catchError, pairwise } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { AuthService, UserType } from '../modules/auth';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SharedService } from './shared.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  private secretKey = "qubeappsPro_token";
  private previousRoute: string;
  private baseRoute:string = "/customers/customerprofile/customer-audit";
  baseURL: string = environment.HTTP;
  prodURL: string = 'https://qubeapi.com/api/central';


  currentUserSubject: BehaviorSubject<UserType>;
  
  constructor(private shareService:SharedService,private auth: AuthService, private router: Router) { 
    this.router.events
    .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
    .subscribe((events: RoutesRecognized[]) => {
      this.previousRoute = events[0].urlAfterRedirects
      this.previousRoute = this.previousRoute.split('?')[0];
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const token = localStorage.getItem('access_token');
    // const licenseUrl = this.baseURL == this.prodURL ? 'https://qubeapi.com:8089/smartlock/api/1.0/license' : 'https://smartlock-dev.qubeposcloud-uatapi.com/smartlock/api/1.0/license';
    // const upgradingUrl = this.baseURL == this.prodURL ? 'https://qubeapi.com:8089/smartlock/api/1.0/upgrading' : 'https://smartlock-dev.qubeposcloud-uatapi.com/smartlock/api/1.0/upgrading';
    // const logUrl = this.baseURL == this.prodURL ? 'https://qubeapi.com:8089/smartlock/api/1.0/activities' : 'https://smartlock-dev.qubeposcloud-uatapi.com/smartlock/api/1.0/activities';
    // const healthUrl = this.baseURL == this.prodURL ? 'https://qubeapi.com:8089/smartlock/healthcheck' : 'https://smartlock-dev.qubeposcloud-uatapi.com/smartlock/healthcheck';
    // const exportUrl = this.baseURL == this.prodURL ? 'https://qubeapi.com:8089/smartlock/api/1.0/activities/export' : 'https://smartlock-dev.qubeposcloud-uatapi.com/smartlock/api/1.0/activities';

    // if (request.url === licenseUrl || request.url === upgradingUrl || request.url === logUrl || request.url === healthUrl || request.url === exportUrl) {
    //   // Set Basic Auth for smartlock license API
    //   const basicAuth = 'Basic ' + 'VTAxQlVsUk1UME5MOlRVQnpkR1Z5U3pOWg==';
    //   request = request.clone({
    //     setHeaders: {
    //       // 'Content-Type': 'application/json',
    //       Authorization: basicAuth,
    //       // 'mode': 'no-cors',
    //       // "Access-Control-Allow-Origin" : "*"
    //     }
    //   });
    const smartlockBaseURL = this.baseURL === this.prodURL
    ? 'https://qubeapi.com:8089/smartlock'
    : 'https://smartlock-dev.qubeposcloud-uatapi.com/smartlock';

    const smartlockPaths = [
      '/api/1.0/license',
      '/api/1.0/upgrading',
      '/api/1.0/activities',
      '/healthcheck',
      '/api/1.0/activities/export'
    ];

    const isSmartlockRequest = smartlockPaths.some(path =>
      request.url === `${smartlockBaseURL}${path}`
    );

    if (isSmartlockRequest) {
      const basicAuth = 'Basic VTAxQlVsUk1UME5MOlRVQnpkR1Z5U3pOWg==';
      request = request.clone({
        setHeaders: {
          Authorization: basicAuth
        }
      });
    } else if (token) {
      const decryptedAccessToken = JSON.parse(CryptoJS.AES.decrypt(token, this.secretKey).toString(CryptoJS.enc.Utf8));
      if (this.isFormData(request.body)) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${decryptedAccessToken}`
          }
        });
      } else {
        request = request.clone({
          setHeaders: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            Authorization: `Bearer ${decryptedAccessToken}`
          }
        });
      }
    }

    return next.handle(request).pipe(
      catchError( (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.auth.revokeall();
          return EMPTY;
        } else if (error.status === 503) {
          this.router.navigate(['error/500']);
          return EMPTY;
        }else if (error.status === 403) {
          this.shareService.hideSpinner();
          if(this.previousRoute == this.baseRoute)
          {   
            from(Swal.fire({
              text: "Permission Denied",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                  confirmButton: "btn fw-bold btn-primary",
              }
              }).then((result)=> {
                window.history.back();
              }));
          }else
          {
            from(Swal.fire({
              text: "Permission Denied",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                  confirmButton: "btn fw-bold btn-primary",
              }
              }).then((result)=> {
                window.history.back();
              }));
          }
        }else if (error.status === 409) {
          from(Swal.fire({
            title: 'Conflict Submission',
            text: error?.error?.message,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Ok, got it!',
            customClass: {
              confirmButton: "btn fw-bold btn-primary",
          }
          }).then(() => {
            this.shareService.triggerReload();
          }));
          this.shareService.hideSpinner();
        }else if (error.status === 500) {
          from(Swal.fire({
            title: 'Error',
            text: error?.error?.message?.replace(/_/g, ' '),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Ok, got it!',
            customClass: {
              confirmButton: "btn fw-bold btn-primary",
          }
          }).then(() => {
            // this.shareService.triggerReload();
            
          }));
          this.shareService.hideSpinner();
        }

        // Handle any other errors
        return throwError(() => error);
      })
    );
  }

  isFormData(value: any): boolean {
    return (typeof FormData !== 'undefined') && (value instanceof FormData);
  }
}
